import '../../Css/BigBtn.css'
import React from "react";

const Button = ({ as: Tag = "button", children, filled, secondary, ...rest }) => {
  const className = `dir-control${secondary ? " dir-control--secondary" : ""}${
    filled ? " dir-control--filled" : ""
  }`;

  return (
    <Tag className={className} {...rest}>
      {children}
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <b aria-hidden="true">{children}</b>
      <b aria-hidden="true">{children}</b>
      <b aria-hidden="true">{children}</b>
      <b aria-hidden="true">{children}</b>
    </Tag>
  );
};


export default Button;
